export default "__VITE_ASSET__BZ2RlHV___"